




























































































import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { EditUserData } from '@/modules/backend/Dto/EditUserData';
import { UserName } from '@/modules/backend/Entities/UserName';
import { Mixins, Prop, Ref } from 'vue-property-decorator';
import { User } from '@/modules/backend/Entities/User';
import { Role } from '@/modules/backend/Entities/Role';
import ProvidersModule from '@/store/dashboard/providers/ProvidersModule';
import { resolveModule } from '@/store';
import EditDialogWrapper from '@/layouts/EditDialogWrapper.vue';
import { Provider } from '@/modules/backend/Entities/Provider';
import Mixin from '@/mixins/base';
import { CompaniesModule } from '@/store/dashboard/companies/CompaniesModule';
import { ValidationObserver } from '@/plugins/vee-validate';

const UsersModule = namespace('dashboard/users');
const RolesModule = namespace('dashboard/roles');

interface EditUserForm {
  lastName: string;
  firstName: string;
  patronymic: string;
  email: string;
}

@Component({
  mixins: [Mixin],
  components: {
    'edit-dialog-wrapper': EditDialogWrapper
  }
})
export default class UserEditDialog extends Mixins(Mixin) {
  private readonly companiesModule: CompaniesModule = resolveModule(CompaniesModule);

  @Ref('observer')
  private readonly observer!: ValidationObserver;

  @UsersModule.Action('Edit')
  public editUser!: (payload: EditUserData) => Promise<void>;

  @RolesModule.Action('List')
  public fetchRoles!: () => Promise<void>;

  @RolesModule.Getter('Roles')
  public readonly roles!: Role[];

  private readonly providersModule: ProvidersModule = resolveModule(ProvidersModule);
  @Prop({ required: true })
  private readonly userId!: number;

  @UsersModule.Getter('UserById')
  private userById!: (userId: number) => User;

  private myRoles: number[] = [];
  private myCompanies: number[] = [];
  private myProviders: number[] = [];

  private get currentUser(): User {
    return this.userById(this.userId);
  }

  private get providers(): Provider[] {
    return this.providersModule.providers;
  }

  private get form(): EditUserForm {
    return {
      firstName: this.currentUser.getName().getFirst(),
      lastName: this.currentUser.getName().getLast(),
      patronymic: this.currentUser.getName().getPatronymic(),
      email: this.currentUser.getEmail()
    };
  }

  private clearForm(): void {
    this.form.firstName = this.currentUser.getName().getFirst();
    this.form.lastName = this.currentUser.getName().getLast();
    this.form.patronymic = this.currentUser.getName().getPatronymic();
    this.form.email = this.currentUser.getEmail();
    this.observer.reset();
  }

  private async dialogOpenHandler(): Promise<void> {
    this.clearForm();

    this.myRoles = this.currentUser.getRoles().map((role) => role.getId());
    this.myCompanies = this.currentUser.getCompanies().map((item) => item.getId());
    this.myProviders = this.currentUser.getProviders().map((item) => item.getId());
    await Promise.all([
      this.providersModule.fetch(),
      this.companiesModule.Fetch(),
      this.fetchRoles()
    ]);
  }

  public async edit(): Promise<void> {
    this.observer.reset();

    if (await this.observer.validate()) {
      const payload = new EditUserData();
      payload.id = this.currentUser.getId();
      payload.email = this.form.email !== this.currentUser.getEmail()
        ? this.form.email
        : undefined;
      payload.name = new UserName(
        this.form.firstName,
        this.form.lastName,
        this.form.patronymic
      );
      payload.companyIds = this.myCompanies;
      payload.roleIds = this.myRoles;
      payload.providerIds = this.myProviders;
      await this.editUser(payload);
    } else {
      throw new Error('Validation error');
    }
  }
}
